<div class="tvshop-header"
     [class.tvshop-header--width__85vw]="rendition === StreamingBundleProductTypeRendition"
     *ngIf="showTvShopHeader">
  <div class="product-detail-header-title" [translate]="titleKey"></div>
  <div class="browser-url" *ngIf="shouldDisplayCurrentBrowserAddress">{{currentBrowserAddress}} - CN:
    {{currentCustomer | async}}, DTV: {{currentDtvIdentifier | async}}
  </div>
  <div class="product-detail-header-clock">{{ clockTime | date:'HH:mm' }}</div>
  <app-info-maintenance *ngIf="isThereMaintenancePlanned"
                        [maintenanceModeConfig]="maintenanceModeConfig"></app-info-maintenance>
</div>
